import { makeStyles } from "tss-react/mui";

export const MaxHeightImageContainer = 256;
export const MaxWidthImageContainer = 256;

export const ImageHandlerStyles = makeStyles()(
    (theme, p, classes) => ({
        imageContainer: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            maxHeight: "450px",
            padding: "4px",
            backgroundColor: "#808080",
            "& img": {
                maxHeight: "450px",
                maxWidth: "100%"
            }
        },

        imageBorder: {
            textAlign: "center",
            border: "solid 1px #000",
        },

        imageCrop: {
            height: MaxHeightImageContainer
        },

        imageBoxArea: {
            width: MaxWidthImageContainer,
            height: MaxHeightImageContainer,
            margin: "0 auto",
            display: "block",
            backgroundColor: "#000",
        },

        previewImageW: {
            maxWidth: "100%"
        },
        previewImageH: {
            maxHeight: "100%"
        },
    })
);
